import { Injectable } from "@angular/core";
import { NavStorageService } from "../../nav-storage/services/nav-storage.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export abstract class NavTabStateComponent<T> {
  me: any;
  saveState = false;

  constructor(protected navStorageService: NavStorageService, tab: T, public router2: Router,) {
    this.me = tab
    this.saveState = true;
  }

  /**
   * Estado de la información mientras se tiene abierto la pestaña
   */
  initSessionState() {
    if(this.me.tag === "patient-info")
      this.updateSessionStatePatient();
    //consulta y asigna el estado de la view
    if (!this.navStorageService.exists(this.me.tag)) {
      this.me = this.newState(this.me);
    } else{
      let url = this.me.url;
      this.me = this.navStorageService.getItem<T>(this.me.tag);
      if (this.me.url !== url) {
        this.navStorageService.removeItem(this.me.tag);
        this.me.url = url;
        this.me = this.newState(this.me);
      }
    }
    if(this.me.tag !== "patient-info")
      this.me.activeTab = true;
    this.navStorageService.setItem(this.me.tag, this.me);
    this.setViewState();
  }
  updateSessionState() {
    if (this.navStorageService.exists(this.me.tag)) {
      this.me.activeTab = true;
      this.navStorageService.setItem(this.me.tag, this.me);
    }
  }

  updateSessionStatePatient() {
    if (this.navStorageService.exists(this.me.tag)) {
      let tab: any = this.navStorageService.getItem<T>(this.me.tag);
      if(tab.patient.patient.data.id && !this.me.patient.patient.data.id){
        this.me = tab;
      }
      this.me.activeTab = false;
      this.navStorageService.setItem(this.me.tag, this.me);
      this.setViewState();
    }
  }
  /**
   * Cierra el estado de la pantalla, para ello verifica si existe.
   */
  private closeSessionState() {
    if (this.navStorageService.exists(this.me.tag)) {
      this.me.activeTab = false;
      this.navStorageService.setItem(this.me.tag, this.me);
    }
  }
  /**
   * Funcion que valida cierra la sesion de la pantalla
   */
  beforeCloseSessionState(bandera?: boolean) {
    if (this.navStorageService.exists(this.me.tag)) {
      if ((this.me.url.includes('/patient/gine-triage') || this.me.url.includes('/patient/general-triage')) && (bandera === false)) {
        if(!this.me.url.includes('/patient/general-triage/result') && !this.me.url.includes('/patient/gine-triage/result')) {
          const confirmExit = confirm("¿Estás seguro de que deseas salir sin guardar cambios?");
          if (confirmExit && this.navStorageService.exists(this.me.tag)) {
            this.beforeClose();
          }
        }
      } else {
        this.beforeClose();
      }
    }
  }

  private beforeClose(){
    this.me.activeTab = false;
    this.getViewState();
    this.closeSessionState();
  }


  abstract getViewState();
  abstract setViewState();
  abstract newState(model: T): T;
  abstract getFormControl();
  abstract setFormControl(aux: any);
}
